import { Injectable } from '@angular/core';
import { ApiService } from '@hospitality-bot/shared/utils';
import { Observable } from 'rxjs';
import {
  MenuFormData,
  MenuItemForm,
  MenuItemListResponse,
  MenuItemResponse,
  MenuListResponse,
  MenuResponse,
} from '../types/menu.types';
import { QueryConfig } from '@hospitality-bot/admin/shared';

@Injectable({ providedIn: 'root' })
export class MenuService extends ApiService {
  getMenuList(
    config: QueryConfig,
    entityId: string
  ): Observable<MenuListResponse> {
    return this.get(`/api/v1/menus${config.params}`, {
      headers: { 'entity-id': entityId },
    });
  }
  exportCSV(config: QueryConfig, entityId: string) {
    return this.get(`/api/v1/menus/export${config.params ?? ''}`, {
      responseType: 'blob',
    });
  }

  importMenuItem(
    menuId: string,
    data,
    headers = this.preDefinedHeaders
  ): Observable<MenuItemForm[]> {
    return this.post(
      `/api/v1/menus/${menuId}/validate-items
 `,
      data,
      headers
    );
  }

  getMenu(menuId: string, entityId: string): Observable<MenuResponse> {
    return this.get(`/api/v1/menus/${menuId}`, {
      headers: { 'entity-id': entityId },
    });
  }

  addMenu(data: MenuFormData, entityId: string): Observable<MenuResponse> {
    return this.post(`/api/v1/menus`, data, {
      headers: { 'entity-id': entityId },
    });
  }

  updateMenu(
    data: MenuFormData,
    menuId: string,
    entityId: string
  ): Observable<any> {
    return this.patch(`/api/v1/menus/${menuId}`, data, {
      headers: { 'entity-id': entityId },
    });
  }

  getMenuItemsById(menuItemId: string): Observable<any> {
    return this.get(`/api/v1/menus/items/${menuItemId}`);
  }

  addMenuItemsList(
    data: MenuItemForm[],
    menuItemId: string,
    outletId: string
  ): Observable<any> {
    return this.post(`/api/v1/menus/${menuItemId}/menu-items`, data, {
      headers: { 'entity-id': outletId },
    });
  }

  addMenuItems(
    data: MenuItemForm,
    menuId: string,
    outletId: string
  ): Observable<MenuItemResponse> {
    return this.post(`/api/v1/menus/items?menuId=${menuId}`, data, {
      headers: { 'entity-id': outletId },
    });
  }

  updateMenuItems(
    data: Partial<MenuItemForm>,
    menuItemId: string,
    menuId: string
  ): Observable<any> {
    return this.patch(`/api/v1/menus/items/${menuItemId}`, data, {
      headers: { entityId: menuId },
    });
  }

  getMenuItems(
    config: QueryConfig,
    outletId: string
  ): Observable<MenuItemListResponse> {
    return this.get(`/api/v1/menus/items${config.params}`, {
      headers: { 'entity-id': outletId },
    });
  }

  exportMenuItemsCSV(config: QueryConfig, entityId: string) {
    return this.get(`/api/v1/menus/items/export${config.params ?? ''}`, {
      responseType: 'blob',
      headers: { 'entity-id': entityId },
    });
  }

  getAllCategories(entityId: string, config: QueryConfig) {
    return this.get(`/api/v1/entity/${entityId}/categories${config.params}`);
  }
}
